import { TenantCustomer } from '~/tenants/common/TenantPersona';

export default class PicCustomer extends TenantCustomer {}
